export default "__VITE_ASSET__QAAyi4Av__"